import { forceLogout } from '../apis/authentication';

function check_expiry(expiry: string | null | undefined) {
  if (expiry) {
    const now = Math.trunc(new Date().getTime() / 1000);
    if (parseInt(expiry) > now) {
      return true;
    }
  }
  forceLogout();
  return false;
}

export function isCookieSetAndValid(cookieName: string, mode?: string): boolean {
  if (mode === 'addon') {
    const expiry = localStorage.getItem(cookieName);
    return check_expiry(expiry);
  }
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();

    // Check if the cookie starts with the specified name
    if (cookie.startsWith(cookieName + '=')) {
      const value = cookie.split('=')[1];
      return check_expiry(value);
    }
  }

  return false;
}

export function isCookieSet(cookieName: string): boolean {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();

    // Check if the cookie starts with the specified name
    if (cookie.startsWith(cookieName + '=')) {
      return true;
    }
  }

  return false;
}

export function getCookie(cookieName: string): string {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();

    // Check if the cookie starts with the specified name
    if (cookie.startsWith(cookieName + '=')) {
      return decodeURIComponent(cookie.substring(cookieName.length + 1, cookie.length));
    }
  }

  return '';
}

export const setCookie = (name: string, value: string) => {
  const hostname = window.location.hostname;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  const attributes = ['Path=/'];
  if (!isLocalhost) {
    const domain = `.${hostname.split('.').slice(1).join('.')}`;
    attributes.push(`Domain=${domain}`, 'Secure', 'SameSite=None');
  } else {
    attributes.push('SameSite=Lax');
  }
  document.cookie = `${name}=${encodeURIComponent(value)};${attributes.join(';')}`;
};

export const setCookieForTeams = (name: string, value: string) => {
  const hostname = window.location.hostname;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  
  let cookieString = `${name}=${value}; Path=/; Max-Age=3600; SameSite=None; Secure`;
  
  document.cookie = cookieString;
  
  if (!isLocalhost && hostname.includes('.')) {
    const rootDomain = hostname.split('.').slice(-2).join('.');
    document.cookie = `${cookieString}; Domain=.${rootDomain}`;
  }
};
